var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.token_exists)?_c('div',[_c('statements-report-table',{attrs:{"api_base_path":_vm.api_base_path,"fetch_starshop":_vm.fetch_starshop}})],1):_c('div',[_vm._v("\n        "+_vm._s(_vm.$t('label.token_does_not_exist'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }